import { memo } from "react";

/**
 * FinancialMetricCard
 *
 * A single metric card for the Financial Dashboard key-metrics row.
 * Matches the InvoicingDashboard StatCard style but adds an icon.
 *
 * Props:
 *   icon    — emoji or string (optional)
 *   label   — uppercase label text
 *   value   — formatted value string (e.g. "£1,234.56")
 *   sub     — sub-label text (e.g. "3 invoices")
 *   color   — value text colour (default navy)
 *   subColor — sub-label colour (default #aaa)
 */
function FinancialMetricCard({ icon, label, value, sub, color, subColor }) {
  const isMobileLayout = typeof window !== "undefined"
    && (window.innerWidth <= 1024 || window.matchMedia("(pointer: coarse)").matches);

  return (
    <div style={{
      flex: isMobileLayout ? "1 1 100%" : "1 1 155px",
      minWidth: isMobileLayout ? 0 : 150,
      padding: "1rem 1.1rem",
      background: "#fff",
      border: "1px solid #35454C",
      borderRadius: 12,
      boxShadow: "0 1px 4px rgba(0,0,0,0.04)",
      display: "flex",
      flexDirection: "column",
      gap: "0.2rem",
    }}>
      <div style={{ display: "flex", alignItems: "center", gap: "0.4rem" }}>
        {icon && (
          <span style={{ fontSize: "1rem", lineHeight: 1 }}>{icon}</span>
        )}
        <span style={{
          fontSize: "0.68rem",
          fontWeight: 700,
          color: "#aaa",
          textTransform: "uppercase",
          letterSpacing: "0.06em",
          fontFamily: "Raleway, sans-serif",
        }}>
          {label}
        </span>
      </div>

      <div style={{
        fontSize: "1.5rem",
        fontWeight: 900,
        color: color || "#0C2D48",
        lineHeight: 1.15,
        fontFamily: "Raleway, sans-serif",
        marginTop: "0.1rem",
      }}>
        {value}
      </div>

      {sub && (
        <div style={{
          fontSize: "0.74rem",
          color: subColor || "#aaa",
          fontFamily: "Raleway, sans-serif",
          marginTop: "0.1rem",
        }}>
          {sub}
        </div>
      )}
    </div>
  );
}

export default memo(FinancialMetricCard);
